import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { VerMapaPage } from '../vermapa/vermapa';

declare var gtag;

@Component({
  selector: 'adddados',
  templateUrl: 'adddados.html'
})

export class AddDadosPage {
	public verMapaPage = VerMapaPage;
	public doencas: Object;
	public coord;
	public coord2;
	public coord3;
	public cidade;
	public cidade2;
	public cidade3;
	public estado;
	public estado2;
	public estado3;
	public user;
	public dependente;
	public sintomas;
	public doenca;
	public dataSintoma;

	doencasFiltradas: string = '';

	constructor(public navCtrl: NavController, public navParams: NavParams, 
				private http: Http) {
		this.coord = navParams.get("coord");
		this.coord2 = navParams.get("coord2");
		this.coord3 = navParams.get("coord3");
	   	this.cidade = navParams.get("cidade");
	   	this.cidade2 = navParams.get("cidade2");
	   	this.cidade3 = navParams.get("cidade3");
	   	this.estado = navParams.get("estado");
	   	this.estado2 = navParams.get("estado2");
	   	this.estado3 = navParams.get("estado3");
	    this.user = navParams.get("user");
	   	this.dependente = navParams.get("dependente");
		this.sintomas = navParams.get("sintomas");
	}

	ionViewWillLoad(){
	    this.getData();
	}

	ionViewDidLoad(){
		let data = new Date();
		
		let dd = data.getDate();
		let mm = data.getMonth()+1;
		let yyyy = data.getFullYear();

		let dia = dd < 10 ? "0"+dd : dd;
		let mes = mm < 10 ? "0"+mm : mm;
		
		let hoje = yyyy+"-"+mes+"-"+dia;

		(<HTMLInputElement>document.getElementById('data')).value = hoje;
	}

	houveSuspeita(e:any){
		var suspeita = document.getElementById("suspeita");
		suspeita.style.display = suspeita.style.display === 'none' ? '' : 'none';
	}

	getDoenca(id){
		this.doenca = id;
	}

	filtrar(){
		this.respGetData(this.doencasFiltradas).subscribe(data => {
			this.doencas = data;
		});
	}

	addOcorrencia(){
		var data = (<HTMLInputElement>document.getElementById('data')).value;
		var suspeita = document.getElementById("suspeita");

		if(!this.doenca || suspeita.style.display === 'none')
			this.doenca = "";

		var consultou = this.doenca === "" ? "Não" : "Sim";

		if(!data){
			this.dataSintoma = new Date();
		} else {
			this.dataSintoma = data;
		}

		document.getElementById("add-ocorrencia").setAttribute("disabled", "disabled");
		let headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/x-www-form-urlencoded' );
        let options = new RequestOptions({ headers: headers });
     	
     	var postParams = JSON.stringify({
        	coord: this.coord,
        	cidade: this.cidade,
        	estado: this.estado,
        	idPai: this.user,
        	idDependente: this.dependente,
        	sintoma: this.sintomas,
        	doenca: this.doenca,
        	consultou: consultou,
        	detalhes: "",
        	suspeita: "",
        	data: this.dataSintoma
        });

		var link = 'http://maisalguemdoente.com.br/ocorrencias/webService/setOcorrencia';
        
		this.http.post(link, postParams, options).map(res => res.json())
    	.subscribe(
            data => {
            	if(!this.coord2){
					gtag('event', 'add-ocorrencia');
            		this.navCtrl.setRoot(VerMapaPage, {inserido: "inserido"});
            	}
            },
            err => {
              console.log("ERROR!: ", err);
            }
    	);

    	if(this.coord2){
    		var postParams2 = JSON.stringify({
	        	coord: this.coord2,
	        	cidade: this.cidade2,
	        	estado: this.estado2,
	        	idPai: this.user,
	        	idDependente: this.dependente,
	        	sintoma: this.sintomas,
	        	doenca: this.doenca,
	        	consultou: consultou,
	        	detalhes: "",
	        	suspeita: "",
	        	data: data
	        });

	        this.http.post(link, postParams2, options).map(res => res.json()).subscribe(
	            data => {
	            	if(!this.coord3){
						gtag('event', 'add-ocorrencia');
	            		this.navCtrl.setRoot(VerMapaPage, {inserido: "inserido"});
	            	}
	            },
	            err => {
	              console.log("ERROR!: ", err);
	            }
        	);
    	}

    	if(this.coord3){
    		var postParams3 = JSON.stringify({
	        	coord: this.coord3,
	        	cidade: this.cidade3,
	        	estado: this.estado3,
	        	idPai: this.user,
	        	idDependente: this.dependente,
	        	sintoma: this.sintomas,
	        	doenca: this.doenca,
	        	consultou: consultou,
	        	detalhes: "",
	        	suspeita: "",
	        	data: data
	        });

	        this.http.post(link, postParams3, options).map(res => res.json()).subscribe(
	            data => {
					gtag('event', 'add-ocorrencia');
	            	this.navCtrl.setRoot(VerMapaPage, {inserido: "inserido"});
	            },
	            err => {
	              console.log("ERROR!: ", err);
	            }
        	);
    	}
	}

	getData(){
		this.respGetData('').subscribe(data => {
			this.doencas = data;
		});
	}

	respGetData(nome): Observable<any> {
    	return this.http.get("http://maisalguemdoente.com.br/doencas/webService/getDoenca?nome="+nome).map((res: Response) => res.json());
  	}
}


// WEBPACK FOOTER //
// ./src/pages/dados/adddados.ts